const emptyQuery = {
  hits: [],
  nbPages: 0,
  page: 0,
  hitsPerPage: 0,
  nbHits: 0,
  exhaustiveTypo: 0,
  exhaustiveNbHits: 0,
  params: '',
  processingTimeMS: 0,
  query: '',
};

const DEFAULT_HITS_PER_PAGE = 50;

// Max number of results to obtain from search query
// Copy E1 implementation
const MAX_NUM_SEARCH_RESULTS = 300;

// All E2 templates have accessible category
const E2_TEMPLATE_CATEGORY = 'accessible';

export { emptyQuery, DEFAULT_HITS_PER_PAGE, E2_TEMPLATE_CATEGORY, MAX_NUM_SEARCH_RESULTS };
